import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import MultiselectDemo from './MultiselectDemo';

const MultipleSelection = () => (
	<React.Fragment>
		<ContentHeader title="Multiple Selection" description="Controls for selecting various items at the same time">
		</ContentHeader>
		<ContentBody>
			<Row>
				<Col md={6}>
					<MultiselectDemo />
				</Col>
				<Col md={6}>
				</Col>
			</Row>
			<Row>
				<Col md={6}>
				</Col>
				<Col md={6}>
				</Col>
			</Row>
		</ContentBody>
	</React.Fragment>
)

export default MultipleSelection;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/MultipleSelection/index.js